import { AcaoOperador, EventTypeEnum, RegistroFila } from '../../core/models/alocacao.model';
import { Staff } from '../../core/models/event.model';

/** Ações que o operador pode registrar em campo, a partir da lista de staff. */
export const ACOES_OCORRENCIA: AcaoOperador[] = [
  { label: 'Iniciar',      eventTypeEnum: 'start',        icone: 'play_arrow',   allowedFrom: ['scheduler'],           observacaoObrigatoria: false },
  { label: 'Concluído',    eventTypeEnum: 'end_success',  icone: 'check_circle', allowedFrom: ['start'],               observacaoObrigatoria: false },
  { label: 'Deserção',     eventTypeEnum: 'end_failure',  icone: 'person_off',   allowedFrom: ['start'],               observacaoObrigatoria: true  },
  { label: 'Ocorrência',   eventTypeEnum: 'notification', icone: 'report',       allowedFrom: ['start'],               observacaoObrigatoria: true  },
  { label: 'Disciplina',   eventTypeEnum: 'notification', icone: 'gavel',        allowedFrom: ['start'],               observacaoObrigatoria: true  },
  { label: 'Troca Função', eventTypeEnum: 'change_job',   icone: 'swap_horiz',   allowedFrom: ['scheduler', 'start'],  observacaoObrigatoria: false },
];

/** Ações que apenas registram, sem alterar o status do membro. */
export const ACOES_SEM_MUDANCA_STATUS = new Set<EventTypeEnum>(['notification']);

/**
 * Normaliza o enum vindo do staff-manager ('scheduled') para o enum de
 * operação usado nas ações ('scheduler'). Os demais valores são equivalentes.
 */
export function normalizarStatus(eventTypeEnum: string): EventTypeEnum {
  return eventTypeEnum === 'scheduled' ? 'scheduler' : (eventTypeEnum as EventTypeEnum);
}

export function isAcaoPermitida(acao: AcaoOperador, statusAtual: EventTypeEnum): boolean {
  return acao.allowedFrom.includes(statusAtual);
}

/**
 * Converte um Staff (modelo aninhado do staff-manager) em um RegistroFila
 * pronto para sincronização.
 */
export function staffParaRegistro(
  staff: Staff,
  celebrationJobLocationId: string,
  localNome: string,
  acao: AcaoOperador,
  observacao: string,
): RegistroFila {
  return {
    memberId: staff.member.id,
    celebrationJobLocationId,
    localNome,
    membroNome: staff.member.nomeCompleto || staff.member.nomeColete,
    acao: acao.label,
    eventTypeEnum: acao.eventTypeEnum,
    observacao,
    dataHora: new Date().toISOString(),
  };
}
